import * as React from "react";
import type { SVGProps } from "react";
const SvgSpaceHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 21.6H2.4M21.6 2.4H2.4m12 13.17L12 18m0 0-2.4-2.43M12 18V6M9.6 8.43 12 6m0 0 2.4 2.43"
    />
  </svg>
);
export default SvgSpaceHeight;
